import {
  REQUEST_ALL_STATIONS,
  RECEIVE_ALL_STATIONS,
  FAILED_ALL_STATIONS,
} from "./../actions/allStationsActions";

export const allStations = (
  state = {
    isFetching: false,
    loadError: false,
    items: [],
    filters: [],
  },
  action
) => {
  switch (action.type) {
    case REQUEST_ALL_STATIONS:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_ALL_STATIONS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.items,
        filters: action.filters,
      });
    case FAILED_ALL_STATIONS:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    default:
      return state;
  }
};
